import React from 'react';
import clsx from 'clsx';

// One avatar for a person everywhere: their photo if there is one, otherwise their initials on ONE
// flat colour derived from their id, so the same person has the same colour on the list, the
// profile, the sidebar and search. (Before, the colour came from the row position or a gradient
// picked per screen, so someone changed colour whenever a list was re-sorted.)
const PALETTE = ['#4f46e5', '#0284c7', '#0d9488', '#059669', '#d97706', '#e11d48', '#7c3aed', '#475569'];

export const avatarColor = (seed) => {
  const s = String(seed || '');
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length];
};

const SIZE = {
  xs: 'w-6 h-6 text-[10px]', sm: 'w-8 h-8 text-xs', md: 'w-10 h-10 text-sm', lg: 'w-12 h-12 text-base', xl: 'w-16 h-16 text-lg',
};

export default function PersonAvatar({ id, photo, firstName, lastName, name, size = 'sm', square = false, className }) {
  const full = name || `${firstName || ''} ${lastName || ''}`.trim();
  const initials = (((firstName || '')[0] || '') + ((lastName || '')[0] || ''))
    || full.split(/\s+/).map((w) => w[0]).filter(Boolean).slice(0, 2).join('') || '?';
  const cls = clsx(SIZE[size] || size, square ? 'rounded-lg' : 'rounded-full', 'shrink-0 overflow-hidden', className);
  if (photo) return <img src={photo} alt={full || 'Profile photo'} className={clsx(cls, 'object-cover bg-slate-100')} />;
  return (
    <span className={clsx(cls, 'inline-flex items-center justify-center font-semibold text-white select-none')}
      style={{ background: avatarColor(id || full) }} aria-hidden={full ? undefined : true} title={full || undefined}>
      {initials.toUpperCase()}
    </span>
  );
}
